import { render, staticRenderFns } from "./hehuaCulture.vue?vue&type=template&id=35f3e1ce&scoped=true"
import script from "./hehuaCulture.vue?vue&type=script&lang=js"
export * from "./hehuaCulture.vue?vue&type=script&lang=js"
import style0 from "./hehuaCulture.vue?vue&type=style&index=0&id=35f3e1ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f3e1ce",
  null
  
)

export default component.exports